import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React, { useEffect } from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import { PrivilegeEnum } from '../../../../services/common/RolesUtils';
import NotesList from '../../../../containers/notes/NotesList';

function NoteSection({ display,
                      title,
                      tpNotes,
                      fetchTPNotes,
                      createNoteTPCallback,
                      updateNoteTPCallback,
                      deleteNoteTPCallback,
                      hasAnyOfPrivileges,
                      isActionDisabled = false}) {
  const { classes } = useStyles();
  const [isExpanded, setExpanded] = React.useState(true);

  useEffect(() => {
    setExpanded(tpNotes?.length);
  }, [tpNotes]);

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"notes"}>
      <EAAccordion
        title={title}
        logo="note"
        counter={tpNotes?.length}
        opened={isExpanded}
        notificationCounter={0} // TODO change when notifications counter is available
        disabled={
          !hasAnyOfPrivileges(
            PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_NOTES
          )
        }
      >
        {tpNotes && (
          <NotesList
            notes={tpNotes}
            fetchNotes={() => fetchTPNotes()}
            createNote={createNoteTPCallback}
            updateNote={updateNoteTPCallback}
            deleteNote={deleteNoteTPCallback}
            type="THIRD_PARTY"
            isActionDisabled={isActionDisabled}
          />
        )}
      </EAAccordion>
    </Grid>
  );
}

export default NoteSection;
